// src/pages/shrines/AlAbbasShrine.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const AlAbbasShrine = () => {
  // Static image URLs
  const alAbbasMain = "https://ziyaratguide.com/wp-content/uploads/2025/09/ImamHussain.jpg";
  const imamAbbassDetail1 = "https://ziyaratguide.com/wp-content/uploads/2025/09/ImamHussain4.avif";
  const imamAbbasDetail2 = "https://ziyaratguide.com/wp-content/uploads/2025/09/ImamHussain3.avif";
  const imamsDetail3 = "https://ziyaratguide.com/wp-content/uploads/2025/09/ImamHussain2.avif";

  return (
    <>
      <Helmet>
        <title>Al-Abbas (AS) Shrine – Karbala | Ziyarat Guide</title>
        <meta
          name="description"
          content="Discover the shrine of Hazrat Al-Abbas (AS) in Karbala, Iraq — a symbol of loyalty and bravery beside Imam Hussain’s (AS) holy shrine."
        />
        <meta property="og:title" content="Al-Abbas (AS) Shrine – Karbala | Ziyarat Guide" />
        <meta
          property="og:description"
          content="Learn about the life, sacrifice, and shrine of Hazrat Abbas (AS), the flag-bearer of Imam Hussain (AS) and hero of Karbala."
        />
        <meta property="og:image" content={alAbbasMain} />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="imam-page">
        {/* Main content */}
        <div className="imam-content">
          <h1 className="page-title">The Holy Shrine of Al-Abbas (AS)</h1>

          <section className="content-section">
            <p>
              The Holy Shrine of Al-Abbas ibn Ali (peace be upon them both) is a beacon of courage,
              loyalty, and sacrifice. Located in Karbala, Iraq, it stands majestically near the Shrine
              of his brother, Imam Hussain (AS).
            </p>
            <img
              src={alAbbasMain}
              alt="Main view of Al-Abbas Shrine"
              className="imam-image"
            />
          </section>

          <section className="content-section">
            <p>
              Abbas (AS) was the standard-bearer of Imam Hussain (AS) in the Battle of Karbala and is
              revered for his unwavering loyalty and bravery. His sacrifice on the day of Ashura is a
              profound lesson in devotion and selflessness.
            </p>
            <img
              src={imamAbbassDetail1}
              alt="Al-Abbas Shrine detail 1"
              className="imam-image"
            />
          </section>

          <section className="content-section">
            <h2>Significance and History</h2>
            <p>
              The shrine houses the blessed grave of Al-Abbas, who attained martyrdom while attempting
              to fetch water for the thirsty children of Imam Hussain's camp. His hands were severed,
              and he ultimately fell near the Euphrates River. The shrine has undergone numerous
              renovations and expansions throughout history, reflecting the deep reverence Muslims hold
              for him.
            </p>
            <img
              src={imamAbbasDetail2}
              alt="Al-Abbas Shrine detail 2"
              className="imam-image"
            />
          </section>

          <section className="content-section">
            <h2>Visiting the Shrine</h2>
            <p>
              Pilgrims from around the world visit this holy site to pay homage and seek blessings. The
              atmosphere is charged with spiritual energy, devotion, and a deep connection to the
              sacrifices made in Karbala. It is customary for pilgrims to first visit the Shrine of
              Al-Abbas (AS) before proceeding to the Shrine of Imam Hussain (AS).
            </p>
            <img
              src={imamsDetail3}
              alt="Al-Abbas Shrine detail 3"
              className="imam-image"
            />
            <p>May Allah grant us the opportunity to visit these sacred places.</p>
          </section>
        </div>

        {/* Sidebar */}
        <aside className="imam-sidebar">
          <h2>Other Shrines</h2>
          <ul>
            <li>
              <Link to="/shrines/shrine-of-imam-hussain">Imam Hussain (PBUH) Shrine</Link>
            </li>
            <li>
              <Link to="/shrines/al-abbas-shrine">Al Abbas (PBUH) Shrine</Link>
            </li>
            <li>
              <Link to="/shrines/al-mukhayam-shrine">Al-Mukhayam Shrine</Link>
            </li>
            <li>
              <Link to="/shrines/shrine-of-two-sons-muslim-ibn-aqeel">
                Sons of Muslim ibn Aqeel
              </Link>
            </li>
          </ul>
        </aside>
      </div>
    </>
  );
};

export default AlAbbasShrine;
